export default "__VITE_ASSET__IOHizcKJ__"